import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const tools = [
  { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
  { name: 'Next.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg' },
  { name: 'WordPress', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-plain.svg' },
  { name: 'Shopify', icon: 'https://cdn.simpleicons.org/shopify/95BF47' },
  { name: 'Tailwind', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg' },
  { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
  { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
  { name: 'Python', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg' },
  { name: 'TypeScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg' },
  { name: 'Firebase', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg' },
  { name: 'AWS', icon: 'https://cdn.simpleicons.org/amazonaws/232F3E' },
  { name: 'Stripe', icon: 'https://cdn.simpleicons.org/stripe/635BFF' },
  { name: 'Google Ads', icon: 'https://cdn.simpleicons.org/googleads/4285F4' },
  { name: 'Analytics', icon: 'https://cdn.simpleicons.org/googleanalytics/E37400' },
  { name: 'Vercel', icon: 'https://cdn.simpleicons.org/vercel/000000' },
  { name: 'Framer', icon: 'https://cdn.simpleicons.org/framer/0055FF' },
];

const row1 = tools.slice(0, 8);
const row2 = tools.slice(8);

const Partners = () => {
  const { t } = useTranslation();
  return (
    <section data-testid="partners-section" className="py-14 lg:py-20 bg-[#1A1816] relative overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <motion.div className="absolute whitespace-nowrap" style={{ top: '20%' }}
          animate={{ x: ['-20%', '5%'] }} transition={{ duration: 30, repeat: Infinity, ease: 'linear', repeatType: 'reverse' }}>
          <span className="text-[14vw] font-bold text-[#FAF8F5]/[0.015] tracking-[-0.05em] font-sans leading-none">
            TOOLS&nbsp;&nbsp;&nbsp;WE&nbsp;&nbsp;&nbsp;USE&nbsp;&nbsp;&nbsp;TOOLS&nbsp;&nbsp;&nbsp;WE&nbsp;&nbsp;&nbsp;USE
          </span>
        </motion.div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative z-10">
        <motion.div className="text-center mb-12" initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-[1px] bg-[#C9A96E]" />
            <span className="text-[9px] font-semibold tracking-[0.3em] uppercase text-[#C9A96E]">{t('partners.label')}</span>
            <div className="w-10 h-[1px] bg-[#C9A96E]" />
          </div>
          <h2 className="text-xl sm:text-2xl font-sans font-bold text-[#FAF8F5]">
            {t('partners.title1')} <span className="font-serif italic text-[#C9A96E]">{t('partners.title2')}</span>
          </h2>
        </motion.div>

        {/* Marquee row 1 */}
        <div className="mb-6 overflow-hidden">
          <motion.div className="flex gap-6 sm:gap-10"
            animate={{ x: ['0%', '-50%'] }} transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}>
            {[...row1, ...row1].map((tool, i) => (
              <div key={`r1-${i}`} className="flex-shrink-0 flex flex-col items-center gap-3 px-4 py-5 border border-[#FAF8F5]/5 hover:border-[#C9A96E]/30 transition-colors min-w-[100px]"
                data-testid={`partner-${i % row1.length}`}>
                <img src={tool.icon} alt={tool.name} className="w-8 h-8 sm:w-10 sm:h-10 brightness-0 invert opacity-40 hover:opacity-90 transition-opacity" loading="lazy" />
                <span className="text-[9px] sm:text-[10px] text-[#FAF8F5]/40 font-medium tracking-wider uppercase">{tool.name}</span>
              </div>
            ))}
          </motion.div>
        </div>

        {/* Marquee row 2 — opposite direction */}
        <div className="overflow-hidden">
          <motion.div className="flex gap-6 sm:gap-10"
            animate={{ x: ['-50%', '0%'] }} transition={{ duration: 25, repeat: Infinity, ease: 'linear' }}>
            {[...row2, ...row2, ...row2].map((tool, i) => (
              <div key={`r2-${i}`} className="flex-shrink-0 flex flex-col items-center gap-3 px-4 py-5 border border-[#FAF8F5]/5 hover:border-[#C9A96E]/30 transition-colors min-w-[100px]">
                <img src={tool.icon} alt={tool.name} className="w-8 h-8 sm:w-10 sm:h-10 brightness-0 invert opacity-40 hover:opacity-90 transition-opacity" loading="lazy" />
                <span className="text-[9px] sm:text-[10px] text-[#FAF8F5]/40 font-medium tracking-wider uppercase">{tool.name}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
